import { render, staticRenderFns } from "./PlainText.vue?vue&type=template&id=c411fc1c&"
var script = {}
import style0 from "./PlainText.vue?vue&type=style&index=0&id=c411fc1c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports